<div class="form-styles" style="width:400px;height:200px; text-align: center;">
  <h2 mat-dialog-title>{{data.title}}</h2>
  <mat-dialog-content >
    <div class="pb-2">
      {{data.message}}
    </div>
  </mat-dialog-content>
  <div class="mat-form-button-container buttons-align-center mb-0">
    <button mat-raised-button mat-dialog-close color="warn">No</button>
    <button mat-raised-button [mat-dialog-close]="true" color="primary">Yes</button>
  </div>
</div>
